<app-banner></app-banner>

<div class="container-fluid innerPageMenu">
  <div class="row">
      <div class="col-md-3">
          <nav id="secondary-navigation">
              <!-- Header -->
              <header class="header">
                  <h5>About Us</h5>
              </header>
              <!-- /Header -->
              <ul>
                  <li routerLinkActive="active">
                      <a routerLink="/about/overview" >Overview</a>
                  </li>
                  <li routerLinkActive="active">
                    <a routerLink="/about/chairman" >Chairman's Message</a>
                </li>
                <li routerLinkActive="active">
                  <a routerLink="/about/vice-principal" >Vice Principal's Message</a>
              </li>
                  <li routerLinkActive="active">
                      <a routerLink="/about/principal" >Principal's Message</a>
                  </li>
                  <li routerLinkActive="active">
                      <a routerLink="/about/vision" >Vision & Mission</a>
                  </li>
                  
              </ul>
          </nav>
      </div>
      <div class="col-md-9">
          <router-outlet></router-outlet>
      </div>
  </div>
</div>